import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PrimeNGConfig } from 'primeng/api';
import { isNumeric } from 'rxjs/internal-compatibility';
import { DateTimeHelperService } from '../../../../date-time-helper/date-time-helper.service';
import { FilterDropdownControl } from '../../../form-models/filter-dropdown-control';

@Component({
  selector: 'hb-df-filter-dropdown',
  templateUrl: './filter-dropdown.component.html',
  styleUrls: ['./dropdown-style.scss'],
})
export class FilterDropdownComponent implements OnInit{
  @Input() control: FilterDropdownControl;
  @Input() formGroup: FormGroup;

  @Output() onOverrideValue = new EventEmitter();

  constructor(
    private dateTimeHelperService: DateTimeHelperService,
    private primengConfig: PrimeNGConfig)
  {}

  public ngOnInit(): void {

    this.primengConfig.overlayOptions = {
      showTransitionOptions: '0ms linear',
      hideTransitionOptions: '0ms linear',
    };
  }

  formatOptions(options) {
    if (options) {
      let allLabelsAreNumeric: boolean = true;

      options.forEach(option => {
        option.label = this.dateTimeHelperService.replaceIsoUtcDatesInString(option.label);
        allLabelsAreNumeric = allLabelsAreNumeric && isNumeric(option.label);
      });

      if (allLabelsAreNumeric) {
        options.sort((a, b) => (a.label as number) - (b.label as number));
      }

      return options;
    }
  }

  public overrideValue() {
    this.onOverrideValue.emit();
  }
}
